<template>
    <el-dialog class="ah-rich-alert-dialog" :visible="visible" :before-close="handleBeforeClose" :modal-append-to-body="true" append-to-body>
        <div class="body">
            <div class="title">{{ title }}</div>
            <div class="description">{{ description }}</div>
        </div>
        <div class="actions">
            <el-button @click="handleCancelBtnClick">{{ cancelText }}</el-button>
            <el-button type="primary" class="primary-action" @click="handleSubmitBtnClick">{{ submitText }}</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'ah-alert-dialog',
    components: {},
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '標題',
        },
        description: {
            type: String,
            default: '說明文字',
        },
        cancelText: {
            type: String,
            default: '取消',
        },
        submitText: {
            type: String,
            default: '確定',
        },
    },
    data() {
        return {};
    },
    methods: {
        handleCancelBtnClick() {
            this.$emit('cancel');
        },
        handleSubmitBtnClick() {
            this.$emit('submit');
        },
        handleBeforeClose() {
            this.$emit('close');
        },
        showUp() {
            this.show = true;
        }
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.ah-rich-alert-dialog {
    .el-dialog {
        border-radius: 10px;
        width: auto;
        max-width: 450px;
        text-align: center;
    }

    .body {
        margin-bottom: 40px;

        .title {
            font-size: 12pt;
            font-weight: bold;
            color: #222;
            margin-bottom: 10px;
        }

        .description {
            margin: 0 30px;
            color: #888;
        }
    }
}
</style>
